import { Box, TextNew } from '@jfs/ui-new'
import { memo } from 'react'
import { Linking } from 'react-native'
import { APIEndPoints } from '../../network/APIEndpoints'
import { styles } from './styles'

interface ClickableText {
  text: string
  link: string
}

//JIO-PAY LINKS
export const PRIVACY_POLICY = APIEndPoints.privactPolicy
const CONTACT_US = 'https://www.jiopay.in/about'
export const TERMS_AND_CONDITION = APIEndPoints.tnc

const ClickableText = ({ text, link }: ClickableText) => {
  return (
    <Box
      testID={'footer-link-' + text?.replaceAll('', ' ')}
      onPress={() => Linking.openURL(link)}
      {...styles.clickableBox}>
      <TextNew {...styles.linkText}>{text}</TextNew>
    </Box>
  )
}

const VerticalLineSeparator = () => {
  return <Box {...styles.lineSeparator} />
}

const FooterLink = memo(() => {
  return (
    <Box {...styles.container}>
      <ClickableText text={'Privacy Policy'} link={PRIVACY_POLICY} />
      <VerticalLineSeparator />
      <ClickableText text={'Contact Us'} link={CONTACT_US} />
      <VerticalLineSeparator />
      <ClickableText text={'Terms & Conditions'} link={TERMS_AND_CONDITION} />
    </Box>
  )
})

export { FooterLink }
